import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom'; // Import Link
import './Registration.css'; // Ensure the updated CSS is included
import firebase from 'firebase/compat/app';
import emailjs from 'emailjs-com';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import companyLogo from './git_icon.png'; // Replace with your actual logo path

const sendEmail = (userEmail, userName) => {
  const serviceId = 'service_qfbtx8d';
  const templateId = 'template_vau7k77';
  const userId = 'lfdK4JWd6M0aKkTlF'; // EmailJS user ID

  const templateParams = {
    user_email: userEmail,
    user_name: userName,
    reply_to: userEmail,
  };

  emailjs.send(serviceId, templateId, templateParams, userId)
    .then(response => console.log('Registration notification email sent!', response))
    .catch(err => console.error('Failed to send registration notification email. Error: ', err));
};

const RegistrationPage = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleRegister = async () => {
    // Only allow registration for @gitcoatings.com email addresses
    if (!email.endsWith('@gitcoatings.com')) {
      alert('Registration is only allowed for @gitcoatings.com email addresses.');
      return;
    }

    try {
      // Create the user with Firebase authentication
      const userCredential = await firebase.auth().createUserWithEmailAndPassword(email, password);
      const user = userCredential.user;

      console.log('Firebase Auth User created:', user);

      // Send email verification
      await user.sendEmailVerification();

      // Store the user's information in Firestore
      await firebase.firestore().collection('users').doc(user.uid).set({
        name: name,
        email: email,
      });

      console.log('Firestore User document set:', user.uid);

      // Send an additional notification email using EmailJS
      sendEmail(email, name);

      // Sign out the user immediately after registration to prevent access without email verification
      await firebase.auth().signOut();

      // Alert the user and navigate back to login
      alert('Registration successful. Please check your email for verification instructions.');
      navigate('/login');
    } catch (error) {
      handleAuthErrors(error);
    }
  };

  const handleAuthErrors = (error) => {
    if (error.code === 'auth/email-already-in-use') {
      alert('Email address is already in use. Please use a different email.');
    } else if (error.code === 'auth/invalid-email') {
      alert('Invalid email address. Please enter a valid email.');
    } else if (error.code === 'auth/weak-password') {
      alert('Weak password. Please choose a stronger password.');
    } else {
      alert(`Registration failed with error: ${error.code}. Please try again.`);
    }
  };

  return (
    <div className="registration-container">
      <div className="registration-box">
        <img src={companyLogo} alt="Company Logo" className="company-logo" />
        <div className="bold-white">Register</div>
        
        <label htmlFor="name">Name</label>
        <input
          type="text"
          id="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />

        <label htmlFor="email">Email</label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <label htmlFor="password">Password</label>
        <input
          type="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <button onClick={handleRegister}>
          Register
        </button>

        {/* Link to the login page */}
        <div className="login-link">
          Already have an account? <Link to="/login">Go to Login</Link>
        </div>
      </div>
    </div>
  );
};

export default RegistrationPage;
